export default __webpack_public_path__ + "static/media/c9forlife.e3ecc578.jpg";